import { render } from "./BaseField.vue?vue&type=template&id=098a47ee"
import script from "./BaseField.vue?vue&type=script&lang=js"
export * from "./BaseField.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__